<!-- components/TopBanner.vue -->
<template>
  <a 
    :href="link" 
    target="_blank"
    rel="noopener noreferrer"
    class="top-banner"
  >
    <img 
      src="@/assets/adsterra_top.png" 
      alt="Ad"
      class="banner-image"
    />
  </a>
</template>

<script>
export default {
  name: 'TopBanner',
  props: {
    // 链接地址（默认百度）
    link: {
      type: String,
      default: 'https://otieu.com/4/10540026'
    }
  }
};
</script>

<style scoped>
.top-banner {
  display: block;
  width: 100%;
  height: 100px;
  overflow: hidden; /* 防止图片变形溢出 */
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 保持比例并填满容器，可改为 'contain' 如果不想裁剪 */
  display: block;
}
</style>